<template>
    <NeedDetails :hasAllowLiveAppFlag="hasAllowLiveAppFlagComputed"
                 :isCompanyInfoMissing="isCompanyInfoMissingComputed"
                 :isAppDetailsMissing="isAppDetailsMissingComputed"
                 :isWebApp="isWebAppComputed"
                 :canGoLive="canGoLiveComputed"
                 :isPaymentMethodMissing="isPaymentMethodMissingComputed"
                 :provide-more-details-disabled="provideMoreDetailsDisabledComputed"
                 @provideMoreDetails="exportEvent"
    ></NeedDetails>
</template>

<script>
import externalPropsParser from 'services/utils/externalPropsParser';
import NeedDetails from 'monetize/adUnitSettings/NeedDetails';
import eventBus from '@/mixins/eventBus';
import externalParsedProps from '@/mixins/externalParsedProps';

const parsedProps = ['hasAllowLiveAppFlag', 'isCompanyInfoMissing', 'isAppDetailsMissing', 'isWebApp',
    'canGoLive', 'provideMoreDetailsDisabled', 'isPaymentMethodMissing'];

export default {
    name: 'AdUnitSettingsNeedDetailsEx',
    mixins: [
        eventBus('ad-unit-settings-need-details'),
        externalParsedProps(NeedDetails.props, parsedProps)
    ],
    props: externalPropsParser.setExternalProps(NeedDetails.props, parsedProps),
    methods: {
        exportEvent(data) {
            this.$emit('provideMoreDetails', data);
        }
    },
    components: { NeedDetails }
};
</script>
